import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FocusError = () => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      let keys = Object.keys(errors);
      if (keys.length > 0) {
        const selector = `.parametrized-field .MuiFormHelperText-root.MuiFormHelperText-contained.Mui-error`;
        const errorElement = (document.querySelector(selector))?.parentNode as HTMLElement;
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth' })
        } else {
          keys.forEach((key, i) => {
            if (i === 0 && key !== 'quotation') {
              const selector = `[id="${key}"]`;
              const errorElement = (document.querySelector(selector))?.parentNode as HTMLElement;
              if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' })
              }
            }
          });
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default FocusError;